import React, { Component } from 'react'
import styled from 'styled-components'

const PageWrap = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.7;
`
const LoaderWrap = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  & > div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #124b5f transparent transparent transparent;
  }
  & > div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & > div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & > div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

class PageLoader extends Component {
  state = {}
  render() {
    return (
      <PageWrap>
        <LoaderWrap>
          <div />
          <div />
          <div />
          <div />
        </LoaderWrap>
      </PageWrap>
    )
  }
}

export default PageLoader



// WEBPACK FOOTER //
// ./src/components/PageLoader.js